import TipActStep from "./steps/TipActStep";
import ContractOriginalStep from "./steps/ContractOriginalStep";
import ProprietarStep from "./steps/ProprietarStep";
import ChiriasStep from "./steps/ChiriasStep";
import ModificariStep from "./steps/ModificariStep";
import PreviewStep from "./steps/PreviewStep";
import buildActAditionalPDF from "./buildPDF";

const actAditionalInchiriereConfig = {
  buildPDF: buildActAditionalPDF,
  title: "Act Aditional Contract de Inchiriere Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un act aditional valid pentru contractul de inchiriere",
  step1Benefit: "Modifică orice clauză fără să refaci contractul",
  pdfFilename: "act-aditional-contract-inchiriere.pdf",
  downloadLabel: "Descarca Actul Aditional",
  steps: [
    { id: "tipAct", label: "Tip Act", title: "Tipul Actului Adițional", icon: "\u{1F4CB}", component: TipActStep },
    { id: "contractOriginal", label: "Contract", title: "Datele Contractului Original", icon: "\u{1F4C4}", component: ContractOriginalStep },
    { id: "proprietar", label: "Proprietar", title: "Datele Proprietarului", icon: "\u{1F3E0}", component: ProprietarStep },
    { id: "chirias", label: "Chirias", title: "Datele Chiriașului", icon: "\u{1F464}", component: ChiriasStep },
    { id: "modificari", label: "Modificări", title: "Detalii Modificări", icon: "\u{270F}\u{FE0F}", component: ModificariStep },
    { id: "preview", label: "Preview", title: "Previzualizare Act Adițional", icon: "\u{1F4C4}", component: PreviewStep },
  ],
  defaultData: {
    prelungire: false,
    modificareChirie: false,
    modificareClauze: false,
    numarContract: "",
    dataContract: "",
    adresaImobil: "",
    proprietarNume: "",
    proprietarCNP: "",
    proprietarCI: "",
    proprietarAdresa: "",
    chiriasNume: "",
    chiriasCNP: "",
    chiriasCI: "",
    chiriasAdresa: "",
    nouaDataIncetare: "",
    prelungireNedeterminata: false,
    chirieVeche: "",
    chirieVecheMoneda: "EUR",
    chirieNoua: "",
    chirieNouaMoneda: "EUR",
    dataAplicareChirie: "",
    descriereModificare: "",
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "tipAct") {
      if (!data.prelungire && !data.modificareChirie && !data.modificareClauze) {
        errors.tipAct = "Selectează cel puțin un tip de modificare";
      }
    }

    if (stepId === "contractOriginal") {
      if (!data.dataContract) errors.dataContract = "Data contractului este obligatorie";
      if (!data.adresaImobil.trim()) errors.adresaImobil = "Adresa imobilului este obligatorie";
    }

    if (stepId === "proprietar") {
      if (!data.proprietarNume.trim()) {
        errors.proprietarNume = "Numele este obligatoriu";
      } else if (data.proprietarNume.trim().split(/\s+/).length < 2) {
        errors.proprietarNume = "Introduceti numele complet (nume si prenume)";
      }
      if (!data.proprietarAdresa.trim()) errors.proprietarAdresa = "Adresa este obligatorie";
      if (data.proprietarCNP.trim() && !/^\d{13}$/.test(data.proprietarCNP.trim())) {
        errors.proprietarCNP = "CNP-ul trebuie sa contina exact 13 cifre";
      }
      if (data.proprietarCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.proprietarCI.trim())) {
        errors.proprietarCI = "Format invalid (ex: RD 123456 sau RD 1234567)";
      }
    }

    if (stepId === "chirias") {
      if (!data.chiriasNume.trim()) {
        errors.chiriasNume = "Numele este obligatoriu";
      } else if (data.chiriasNume.trim().split(/\s+/).length < 2) {
        errors.chiriasNume = "Introduceti numele complet (nume si prenume)";
      }
      if (!data.chiriasAdresa.trim()) errors.chiriasAdresa = "Adresa este obligatorie";
      if (data.chiriasCNP.trim() && !/^\d{13}$/.test(data.chiriasCNP.trim())) {
        errors.chiriasCNP = "CNP-ul trebuie sa contina exact 13 cifre";
      }
      if (data.chiriasCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.chiriasCI.trim())) {
        errors.chiriasCI = "Format invalid (ex: MZ 654321 sau MZ 6543210)";
      }
    }

    if (stepId === "modificari") {
      if (data.prelungire && !data.prelungireNedeterminata) {
        if (!data.nouaDataIncetare) errors.nouaDataIncetare = "Noua dată de încetare este obligatorie";
      }
      if (data.modificareChirie) {
        if (!data.chirieVeche) errors.chirieVeche = "Chiria veche este obligatorie";
        if (!data.chirieNoua) errors.chirieNoua = "Chiria nouă este obligatorie";
        if (!data.dataAplicareChirie) errors.dataAplicareChirie = "Data de aplicare este obligatorie";
      }
      if (data.modificareClauze) {
        if (!data.descriereModificare.trim()) errors.descriereModificare = "Descrierea modificării este obligatorie";
      }
    }

    return errors;
  },
};

export default actAditionalInchiriereConfig;
